import { render, staticRenderFns } from "./Difference.vue?vue&type=template&id=78270a46&"
import script from "./Difference.vue?vue&type=script&lang=js&"
export * from "./Difference.vue?vue&type=script&lang=js&"
import style0 from "./Difference.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports